const BaseModel = require('../BaseModel');
const BaseChannelTemplate = require('./BaseChannelTemplate');

class EmailChannelTemplate extends BaseChannelTemplate {
  static dataType = 'email-channel-message-template';
}

BaseModel.models[EmailChannelTemplate.dataType] = EmailChannelTemplate;
module.exports = EmailChannelTemplate;
